import { AnimationEvent, usePopup } from '@libs/hooks';
import { TPopupProps } from '@libs/types';
import { Portal } from '@libs/utils';
import React, { useCallback, useEffect, useEffectEvent, useState } from 'react';
import { flushSync } from 'react-dom';
import styles from './Popup.module.css';

export const Popup = ({ content, modal, setPopup }: TPopupProps) => {
    const [animated, setAnimated] = useState(false);
    const [data, setData] = useState<typeof content>(null);
    const { handlers, overlayRef, overlayClick } = usePopup(data, setAnimated, modal);

    const updatePopup = useEffectEvent((currContent: React.ReactNode, currData: React.ReactNode) => {
        if (currContent) {
            setData(currContent);
        } else if (currData) {
            setAnimated(true);
        }
    });

    useEffect(() => {
        updatePopup(content, data);
    }, [content, data]);

    const closeAnimationPopup = useCallback(
        (e: AnimationEvent<HTMLDivElement>) => {
            if (e?.animationName === 'getOutAnimation') {
                flushSync(() => {
                    setData(null);
                    setAnimated(false);
                    setPopup(null);
                });
            }
        },
        [setPopup],
    );

    if (data) {
        const popupBoxClassName = [styles.popupBox, animated && styles.popupBoxAnimated].filter(Boolean).join(' ');
        return (
            <Portal>
                <div id="popup" {...handlers}>
                    <div className={styles.overlay} onClick={overlayClick}>
                        <div className={styles.popupOuter}>
                            <div className={popupBoxClassName} onAnimationEnd={closeAnimationPopup} ref={overlayRef}>
                                {data}
                            </div>
                        </div>
                    </div>
                </div>
            </Portal>
        );
    }
    return null;
};
